import { registerLocaleData } from '@angular/common';
import { availableLocales } from '@locale/config/available-locales';

/**
 * Registers all available locales with Angular
 * This enables proper formatting for DecimalPipe, CurrencyPipe, DatePipe, etc.
 */
export const registerAvailableLocales = (): void => {
  availableLocales.forEach((locale) => {
    registerLocaleData(locale.angularConfig.locale, locale.code);
  });
};
